import { ArrowUpRight } from 'lucide-react';

import { Button } from '@workspace/shadcn';

import { Section } from '../components/section.tsx';
import { BlurFade } from '../components/effects/blur-fade.tsx';

export function AboutUs() {
  return (
    <Section>
      <BlurFade delay={0.5} inView>
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-foreground mb-6 text-3xl font-bold md:text-4xl">
            Al Takassusi General Limited Company (ITGL)
          </h2>
          <p className="text-muted-foreground mb-8 text-lg md:text-xl">
            This platform is ITGL&apos;s initiative to provide the Arab medical
            community a one-stop shop to learn about the latest practices,
            innovations, and trends in the healthcare industry.
          </p>
          <a
            className="group/button mx-auto inline-block w-fit"
            target="_blank"
            rel="noreferrer"
            href="https://www.kfshi.com.sa/en-sa"
          >
            <Button variant="outline" size="lg">
              Visit Our Main Site
              <ArrowUpRight className="ms-2 size-4 transition-transform group-hover/button:-translate-y-0.5 group-hover/button:translate-x-0.5" />
            </Button>
          </a>
        </div>
      </BlurFade>
    </Section>
  );
}
